import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import colors from '../../../../../styles/colors';

const TONE_COLORS = {
  sent: colors.shades.success3,
  fail: colors.shades.danger3,
};

const CampaignCell = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  lineHeight: 1.2,
});

const Count = styled('span', {
  shouldForwardProp: (prop) => prop !== 'tone',
})(({ tone }) => ({
  color: TONE_COLORS[tone] ?? TONE_COLORS.sent,
  fontWeight: 500,
}));

export {
  TONE_COLORS,
  CampaignCell,
  Count,
};
